import { inject } from '@angular/core';
import { NavigationService } from 'app/core/navigation/navigation.service';

export const initialDataResolver = () => {
  const navigationService = inject(NavigationService);

  // Return only navigation data since other services were removed
  return navigationService.get();
};
